<template xmlns="http://www.w3.org/1999/html">
  <section>
    <div class="page-content ticket-list-content">
      <div class="container-fluid">
        <div class="row">
          <!-- Loading from page -->
          <full-loading v-if="loadingList"/>

          <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box">
              <div class="ticket-title col-xs-12 col-sm-12 col-md-12">
                <div class="ticket-span-title">
                  <span>#{{ dataCode.id }}</span> Ticket : {{ dataCode.title }}
                  <a data-toggle="modal" @click="modalChangeName()">
                    <ion-icon class="button-circle" name="create-outline"></ion-icon>
                  </a>
                </div>
                <span @click="backTickets()" title="Voltar a tela de tickets" class="back-tickets">
                  <ion-icon name="arrow-back-outline"></ion-icon>
                  Voltar
                </span>
                <span>Id da empresa: {{ dataCode.companyId }}</span> </br>
                <span>Banco da empresa: {{ dataCode.contentSetting }}</span>
                <div class="ticket-span-subtitle">
                  Criado por {{ dataCode.whoCreatedName }} em {{ dataCode.createdAt | formatDate }} às
                  {{ dataCode.createdAt | formatHors }}
                </div>
                <hr>
              </div>
              <div class="ticket-details col-xs-12 col-sm-12 col-md-12">
                <div class="ticket-card-details col-md-6">
                  <label class="label-icon">
                    Tags
                    <a data-toggle="modal" data-target="#openTags">
                      <ion-icon class="button-circle" name="add-circle-outline"></ion-icon>
                    </a>
                  </label>
                  <div v-for="(t, index) in dataCode.tags" v-bind:class="{'ticket-tags' : true}" :key="index"
                       v-bind:style="{'background-color': t.color}">
                  <span>
                    {{ t.name }}
                  </span>
                  </div>
                </div>
                <div class="ticket-card-details col-md-6 ticket-card-details-two">
                  <label class="label-icon">
                    Prazo
                    <a data-toggle="modal" data-target="#openNewDeadline">
                      <ion-icon class="button-circle" name="create-outline"></ion-icon>
                    </a>
                  </label>
                  <div class="title-details">
                    {{ dataCode.deadLineStr }}
                    <span v-if="dataCode.isLate === true" class="ticket-is-late">
                    Em atraso
                  </span>
                  </div>
                </div>
                <div class="ticket-card col-md-6">
                  <label class="label-icon">
                    Responsáveis
                    <a data-toggle="modal" data-target="#openResponsibles">
                      <ion-icon class="button-circle" name="add-circle-outline"></ion-icon>
                    </a>
                  </label>
                  <div class="ticket-owner">
                  <span v-for="(val, index) in dataCode.responsibles" v-bind:class="{'ticket-responsible' : true}"
                        :key="index">
                    {{ val.name }}
                  </span>
                  </div>
                </div>
                <div class="ticket-card col-md-6">
                  <label class="label-icon">
                    E-mail do cliente
                    <a data-toggle="modal" @click="modalChangeEmail()">
                      <ion-icon class="button-edit" name="create-outline"></ion-icon>
                    </a>
                  </label>
                  <p class="ticket-paragraph">{{ dataCode.clientEmail }}</p>
                </div>
                <div class="ticket-card col-md-6">
                  <label>
                    Empresa
                    <a data-toggle="modal" @click="modalChangeCompany()">
                      <ion-icon class="button-edit" name="create-outline"></ion-icon>
                    </a>
                  </label>
                  <div class="ticket-company">
                    <span class="ticket-span-company" @click="goToFunil()">
                      {{ dataCode.companyName }}
                    </span>
                    <span class="copy-id" title="Copiar ID" @click="copyId()">
                      <ion-icon name="copy-outline"></ion-icon>
                      <span v-if="tooltipVisible">ID copiado!</span>
                    </span>
                  </div>
                </div>
                <div class="ticket-card col-md-6">
                  <label class="label-icon">
                    Link externo
                    <a data-toggle="modal" @click="modalChangeLink()">
                      <ion-icon class="button-edit" name="create-outline"></ion-icon>
                    </a>
                  </label>
                  <p class="ticket-paragraph">
                    <a :href="dataCode.externalLink" target="_blank">{{ dataCode.externalLink }}</a>
                  </p>
                </div>
                <div class="ticket-card">
                  <label>Etapa</label>
                  <div class="ticket-stage">
                    <select v-model="stageSelected" class="ticket-select-stage">
                      <option :selected="stageSelected.id" v-for="(stage, index) in listFilters.stages"
                              v-bind:value="stage.id" :key="index">
                        {{ stage.name }}
                      </option>
                    </select>
                    <button class="btn-save" v-on:click="changeStage(stageSelected)">
                      <span class="span-save" v-if="!loadingStage">
                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                        Salvar
                      </span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
                <div class="ticket-card" v-if="this.dataCode.ticketStage.name === 'Concluído'">
                  <label>Conclusão</label>
                  <div class="ticket-deadline">
                    <div class="title-deadline">
                      {{ dataCode.conclusionDateStr }}
                    </div>
                  </div>
                </div>
                <hr>
              </div>
              <div class="ticket-info col-xs-12 col-sm-12 col-md-12">
                <div class="ticket-card">
                  <label>
                  <span>
                    <ion-icon name="list-outline"></ion-icon>
                    Descrição
                  </span>
                    <button v-on:click="editDescription()">
                      <ion-icon name="pencil-outline"></ion-icon>
                      Editar
                    </button>
                  </label>
                  <div @paste="onPaste" id="toolbarDescription"
                       class="custom-toolbar-description display-none">
                    <vue-editor id="descriptionToolbar"
                                useCustomImageHandler
                                v-model="toolbarValue"
                                :value="toolbarValue"
                                :editorToolbar="customToolbar"
                    />
                    <button class="btn-save-description" v-on:click="saveEditDescription()">
                      <span v-if="!loadingDescription">
                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                        Salvar Alterações
                      </span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                    <button class="btn-cancel-description" v-on:click="cancelEditDescription">cancelar</button>
                  </div>
                  <div id="boxDescription" class="box-description">
                    <div v-html="dataCode.description"></div>
                  </div>
                </div>
                <div class="ticket-card">
                  <label class="ticket-label-attach">
                  <span>
                    <ion-icon name="attach-outline"></ion-icon>
                    Anexos
                  </span>
                    <span class="span-attachments" v-for="(data, index) in dataCode.attachments" :key="index">
                    <a target="_blank" :href="data.fileUri">
                      <br>
                      <ion-icon name="image" v-if="data.fileName.includes('.png')"></ion-icon>
                      <ion-icon name="camera" v-if="data.fileName.includes('.jpg')"></ion-icon>
                      <ion-icon name="document" v-if="data.fileName.includes('.doc')"></ion-icon>
                      <ion-icon name="document" v-if="data.fileName.includes('.rar')"></ion-icon>
                      <ion-icon name="document-text" v-if="data.fileName.includes('.pdf')"></ion-icon>
                      <ion-icon name="document-attach" v-if="data.fileName.includes('.xlsx')"></ion-icon>
                      <ion-icon name="gift-outline" v-if="data.fileName.includes('.gif')"></ion-icon>
                      <ion-icon name="documents-outline" v-if="data.fileName.includes('.jfif')"></ion-icon>

                      {{ data.fileName }}
                    </a>
                    <a v-on:click="removeAttachments(data.id)">
                      <ion-icon class="close-circle-button" name="close-circle"></ion-icon>
                    </a>
                  </span>
                    <br>
                    <span v-if="!this.dataCode.attachments.length" class="span-attachments-else">
                    <ion-icon name="cloud-offline-outline"></ion-icon>
                    SEM ANEXOS ATRIBUÍDOS A ESTE TICKET
                  </span>
                  </label>
                  <br>
                  <div class="button-wrapper">
                    <label v-if="!loadingAttach" class="label" id="labelAttach">
                      <ion-icon name="attach-outline"></ion-icon>
                      Anexar arquivo
                      <input type="file" multiple @change="onAddAttachments" class="upload-box"
                             name="uploadAttach"
                             id="uploadAttach" placeholder="Anexar arquivo">
                    </label>
                    <label class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div class="ticket-history col-xs-12 col-sm-12 col-md-12">
                <div class="ticket-card">
                  <label class="title-history">
                  <span>
                    <ion-icon name="chatbox-ellipses-outline"></ion-icon>
                    Histórico
                  </span>
                  </label>
                  <div @paste="onPaste" id="toolbarHistory"
                       class="toolbar-history">
                    <vue-editor id="historyToolbar"
                                useCustomImageHandler
                                v-model="newAnnotation"
                                :value="newAnnotation"
                                :editorToolbar="customToolbar"
                    />
                  </div>
                  <div class="form-group send-history-line">
                    <button class="btn-send" v-on:click="addAnnotation(newAnnotation)">
                      <div v-if="!loadingAnnotation">
                        <ion-icon name="send"></ion-icon>
                      </div>

                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              <div class="ticket-history col-xs-12 col-sm-123 col-md-12">
                <div class="ticket-card">
                  <div class="box-history-timeline">
                    <div class="nav-timeline">
                      <p v-if="renderTimeline !== 0" @click="renderTimeline = 0"><span>Todos</span></p>
                      <p v-if="renderTimeline === 0" class="active"><span>Todos</span></p>
                      <p v-if="renderTimeline !== 1" @click="renderTimeline = 1"><span>Comentários</span></p>
                      <p v-if="renderTimeline === 1" class="active"><span>Comentários</span></p>
                      <p v-if="renderTimeline !== 2" @click="renderTimeline = 2"><span>Atualizações</span></p>
                      <p v-if="renderTimeline === 2" class="active"><span>Atualizações</span></p>
                    </div>

                    <div v-if="renderTimeline === 0" v-for="(data, index) in dataCode.annotations" :key="index">
                      <div class="general-timeline">
                        <!-- comments -->
                        <label v-if="data.eTicketAnnotationType === 1">
                          {{ data.whoCreatedName }}
                        </label>
                        <div class="comment-timeline-content" v-if="data.eTicketAnnotationType === 1">
                          <p class="date-comment">{{ data.createdAt | formatDate }} às
                            {{ data.createdAt | formatHors24 }}
                          </p>
                          <p class="comment-content" v-for="(text, index) in data.text.split('\n')" :key="index"
                             v-html="text"></p>
                        </div>
                        <!-- attachments -->
                        <div class="content-general bg-stage-yellow" v-if="data.eTicketAnnotationType === 2">
                          <div>
                            <p class="stage-content-general" v-html="data.text"></p>
                            <div class="img-view" v-if="data.text.includes('.png') || data.text.includes('.webp') || data.text.includes('.jpeg') || data.text.includes('.svg') || data.text.includes('.jpg')">
                              <img v-if="!data.text.includes('retirou o anexo') " @click="openGallery(data)" :src="data.textImg" alt="Anexo">
                            </div>
                          </div>
                          <span class="date-stage-general">
                            {{ data.createdAt | formatDate }} às
                            {{ data.createdAt | formatHors24 }}
                          </span>
                        </div>
                        <div class="content-general bg-stage-yellow" v-if="data.eTicketAnnotationType === 99">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                            {{ data.dateToday | formatDate }} às
                            {{ data.dateToday | formatHors24 }}
                          </span>
                        </div>
                        <!-- changed-stage -->
                        <div class="content-general bg-stage-red" v-if="data.eTicketAnnotationType === 3">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-responsable -->
                        <div class="content-general bg-stage-red" v-if="data.eTicketAnnotationType === 4">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-tag -->
                        <div class="content-general bg-stage-blue" v-if="data.eTicketAnnotationType === 5">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-email -->
                        <div class="content-general bg-stage-green" v-if="data.eTicketAnnotationType === 6">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-link -->
                        <div class="content-general bg-stage-green" v-if="data.eTicketAnnotationType === 7">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-deadline -->
                        <div class="content-general bg-stage-blue" v-if="data.eTicketAnnotationType === 8">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-description -->
                        <div class="content-general bg-description" v-if="data.eTicketAnnotationType === 11">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                      </div>
                    </div>

                    <div v-if="renderTimeline === 1" v-for="(data, index) in dataCode.annotations" :key="index">
                      <div class="general-timeline">
                        <label v-if="data.eTicketAnnotationType === 1">
                          {{ data.whoCreatedName }}
                        </label>
                        <div class="comment-timeline-content" v-if="data.eTicketAnnotationType === 1">
                          <p class="date-comment">{{ data.createdAt | formatDate }} às
                            {{ data.createdAt | formatHors24 }}
                          </p>
                          <p class="comment-content" v-for="(text, index) in data.text.split('\n')" :key="index"
                             v-html="text"></p>
                        </div>
                      </div>
                    </div>

                    <div v-if="renderTimeline === 2" v-for="(data, index) in dataCode.annotations" :key="index">
                      <div class="general-timeline">
                        <!-- attachments -->
                        <div class="content-general bg-stage-yellow" v-if="data.eTicketAnnotationType === 2">
                          <div>
                            <p class="stage-content-general" v-html="data.text"></p>
                            <div class="img-view" v-if="data.text.includes('.png') || data.text.includes('.webp') || data.text.includes('.jpeg') || data.text.includes('.svg') || data.text.includes('.jpg')">
                              <img v-if="!data.text.includes('retirou o anexo')" @click="openGallery(data)" :src="data.textImg" alt="Anexo">
                            </div>
                          </div>
                          <span class="date-stage-general">
                            {{ data.createdAt | formatDate }} às
                            {{ data.createdAt | formatHors24 }}
                          </span>
                        </div>
                        <div class="content-general bg-stage-yellow" v-if="data.eTicketAnnotationType === 99">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                            {{ data.dateToday | formatDate }} às
                            {{ data.dateToday | formatHors24 }}
                          </span>
                        </div>
                        <!-- changed-stage -->
                        <div class="content-general bg-stage-red" v-if="data.eTicketAnnotationType === 3">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-responsable -->
                        <div class="content-general bg-stage-red" v-if="data.eTicketAnnotationType === 4">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-tag -->
                        <div class="content-general bg-stage-blue" v-if="data.eTicketAnnotationType === 5">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-email -->
                        <div class="content-general bg-stage-green" v-if="data.eTicketAnnotationType === 6">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-link -->
                        <div class="content-general bg-stage-green" v-if="data.eTicketAnnotationType === 7">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-deadline -->
                        <div class="content-general bg-stage-blue" v-if="data.eTicketAnnotationType === 8">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                        <!-- changed-description -->
                        <div class="content-general bg-description" v-if="data.eTicketAnnotationType === 11">
                          <p class="stage-content-general" v-html="data.text"></p>
                          <span class="date-stage-general">
                          {{ data.createdAt | formatDate }} às
                          {{ data.createdAt | formatHors24 }}
                        </span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div data-toggle="modal" data-target="#"></div>
          </div>
        </div>
        <modal-default modal-title="Tags" modal-id="openTags">
          <input-multi-select col="12" :options="optionsTags" label="Selecionar Tags"
                              @selectedOptions="value => selectedTags = value"/>
          <div class="col-md-12 div-spans">
            <span class="subtitle-span">Tags Vinculadas</span>
            <button v-on:click="removeAllTags()" class="btn-remove-all" type="submit">
              <span class="span-remove-tags" v-if="!loadingTagsRemove">Remover Todos</span>
              <div class="loading-btn" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>
            <br>
            <div class="tags-group">
              <div v-for="(tags, index) in dataCode.tags" :key="index" v-bind:class="{'ticket-tags' : true}"
                   v-bind:style="{'background-color': tags.color}">
                    <span>
                      {{ tags.name }}
                    </span>
                <button v-if="!loadingRemoveTag[index].key" @click="removeTags(tags.id, index)"
                        :disabled="awaitLoadingRemove">
                  <ion-icon name="close-circle"></ion-icon>
                </button>
                <ion-icon v-if="loadingRemoveTag[index].key" class="icon-loading"
                          name="refresh-outline"></ion-icon>
              </div>
            </div>
          </div>
          <btn-search @emit-click="addTags(selectedTags)" have-loading="true" :loading="loadingTags" whichSide="right"
                      label="Salvar"/>
        </modal-default>
        <modal-default modal-title="Responsáveis" modal-id="openResponsibles">
          <input-multi-select-own col="12" :list-items="optionsResponsibles"
                                  @selectedString="value => selectedResponsibles = value"/>
          <div class="col-md-12 div-spans">
            <span class="subtitle-span">Responsáveis Vinculados</span>
            <button v-on:click="removeAllResponsibles()" class="btn-remove-all" type="submit">
              <span class="span-remove-tags" v-if="!loadingTagsRemove">Remover Todos</span>
              <div class="loading-btn" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>
            <br>
            <div class="tags-group">
              <div v-for="(responsibles, index) in dataCode.responsibles" :key="index"
                   v-bind:class="{'ticket-tags' : true}" v-bind:style="{'background-color': '#969696'}">
                    <span>
                      {{ responsibles.name }}
                    </span>
                <button v-if="!loadingRemoveResponsibles[index].key"
                        @click="removeResponsibles(responsibles.userMasterId, index)"
                        :disabled="awaitLoadingRemove"
                >
                  <ion-icon name="close-circle"></ion-icon>
                </button>
                <ion-icon v-if="loadingRemoveResponsibles[index].key" class="icon-loading"
                          name="refresh-outline"></ion-icon>
              </div>
            </div>
          </div>
          <btn-search @emit-click="addResponsibles(selectedResponsibles)" have-loading="true"
                      :loading="loadingResponsibles"
                      whichSide="right"
                      label="Salvar"/>
        </modal-default>

        <div id="openEditName" class="modal fade">
          <div class="modal-dialog modal-dialog-link">
            <div class="modal-content">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box-modal">
                <div class="input-group input-with-date-filter">
                  <label>Novo nome:</label>
                  <div class="inputs-group">
                    <div class="inputs-group-first">
                      <input type="text" class="input-email" v-model="newName">
                    </div>
                  </div>
                  <div class="btn-group">
                    <button class="btn-save-deadline" v-on:click="changeName()">
                      <span class="span-save-deadline" v-if="!loadingName">Salvar</span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="openNewDeadline" class="modal fade">
          <div class="modal-dialog modal-dialog-deadline">
            <div class="modal-content">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box-modal">
                <div class="input-group input-with-date-filter">
                  <label>Prazo:</label>
                  <div class="inputs-group">
                    <div class="inputs-group-first">
                      <datepicker :language="ptBR" :format="customFormatterTicket" v-model="newDeadlineStr._d"/>
                      <ion-icon name="calendar-outline"></ion-icon>
                    </div>
                  </div>
                  <div class="btn-group">
                    <button class="btn-save-deadline" v-on:click="changeDeadline(newDeadlineNull)">
                      <span class="span-save-deadline" v-if="!loadingDeadlineEdit">Salvar</span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="openChangeEmail" class="modal fade">
          <div class="modal-dialog modal-dialog-email">
            <div class="modal-content">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box-modal">
                <div class="input-group input-with-date-filter">
                  <label>E-mail:</label>
                  <div class="inputs-group">
                    <div class="inputs-group-first">
                      <input type="text" class="input-email" v-model="newEmail">
                    </div>
                  </div>
                  <div class="btn-group">
                    <button class="btn-save-deadline" @click="changeEmail()">
                      <span class="span-save-deadline" v-if="!loadingEmailChange">Salvar</span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="openChangeLink" class="modal fade">
          <div class="modal-dialog modal-dialog-link">
            <div class="modal-content">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box-modal">
                <div class="input-group input-with-date-filter">
                  <label>Link externo:</label>
                  <div class="inputs-group">
                    <div class="inputs-group-first">
                      <input type="text" class="input-email" v-model="newExternalLink">
                    </div>
                  </div>
                  <div class="btn-group">
                    <button class="btn-save-deadline" @click="changeLink()">
                      <span class="span-save-deadline" v-if="!loadingLinkChange">Salvar</span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="openChangeCompany" class="modal fade">
          <div class="modal-dialog modal-dialog-link">
            <div class="modal-content">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box-modal">
                <div class="input-group input-with-date-filter">
                  <label>Empresa:</label>
                  <div class="inputs-group">
                    <div class="inputs-group-first">
                      <autocomplete :value="listFilters.companies"/>
                    </div>
                  </div>
                  <div class="btn-group">
                    <button class="btn-save-deadline" @click="changeCompany()">
                      <span class="span-save-deadline" v-if="!loadingCompanyChange">Salvar</span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="gallery" class="gallery-box" id="gallery" @click="closeGallery">
          <ul>
            <li>
            <span
              v-if="galleryImg.text.includes('.png') || galleryImg.text.includes('.jpeg') || galleryImg.text.includes('.svg') || galleryImg.text.includes('.webp') || galleryImg.text.includes('.jpg')">
              <img :src="galleryImg.textImg">
            </span>
            </li>
            <button @click="gallery = false">
              <ion-icon name="close-circle-outline"></ion-icon>
            </button>
          </ul>
          <div class="gallery-control">
            <button @click="prevImg">
              <ion-icon name="caret-back-outline"></ion-icon>
            </button>
            <button @click="nextImg">
              <ion-icon name="caret-forward-outline"></ion-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  CHANGE_TICKETS_FILTERS,
  CREATE_ANNOTATION_TICKETS,
  GET_DATA_TO_FUNIL,
  UPDATE_FILE_ATTACHMENTS,
  UPDATE_TAGS_TICKTS,
  UPDATE_TICKETS,
  UPLOAD_INFO_PROD,
  VIEW_TICKETS
} from "../../../../urlConfig";

import fullLoading from "../../components/default/fullLoading.vue";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import {UTIL_SERVICE} from "../../../../utils";
import {ALERT_SERVICE} from "../../../../msgAlertService";
import {Quill, VueEditor} from "vue2-editor";

import VueMultiselectComponent from 'vue-multiselect-component'
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import autocomplete from "../../components/inputs/inputAutocomplete.vue";

import swal from "sweetalert";
import moment from "moment";
import InputMultiSelect from "../../components/inputs/inputMultiSelect.vue";
import BtnSearch from "../../components/buttons/btnSearch.vue";
import ModalDefault from "../../components/modals/modalDefault.vue";
import InputMultiSelectOwn from "../../components/inputs/inputMultiSelectOwn.vue";
import InputText from "../../components/inputs/inputText.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";

export default {
  name: "list-ticket",
  components: {
    BtnCustom,
    InputMultiSelectOwn,
    ModalDefault,
    BtnSearch,
    InputMultiSelect,
    fullLoading,
    VueMultiselectComponent,
    VueEditor,
    Quill,
    datepicker,
    autocomplete,
    InputText
  },
  props: ['titulo'],
  template: '<label>{{ titulo }}</label>',
  data() {
    return {
      dataCode: {},
      userInfo: '',
      listFilters: {
        companies: [],
        responsibles: [],
        stages: [],
        tags: [],
      },
      ptBR: ptBR,
      newDeadlineStr: {
        _d: ''
      },
      newAnnotation: '',
      addAttachments: [],
      toolbarValue: '',
      stageSelected: '',
      placeholderSelect: 'Selecione',
      selectedTags: [],
      optionsTags: [],
      selectedResponsibles: [],
      optionsResponsibles: [],
      limitTags: 2,
      loadingList: false,
      loadingTicket: false,
      loadingEditor: false,
      showCards: true,
      loadingTags: false,
      loadingResponsibles: false,
      loadingDeadlineEdit: false,
      loadingStage: false,
      loadingTagsRemove: false,
      loadingDescription: false,
      loadingAttach: false,
      loadingAnnotation: false,
      loadingEmailChange: false,
      loadingLinkChange: false,
      loadingCompanyChange: false,
      loadingName: false,
      awaitLoadingRemove: false,
      loadingRemoveTag: [],
      loadingRemoveResponsibles: [],
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{
          'header': 1
        }, {
          'header': 2
        }],
        [{
          list: "ordered"
        }, {
          list: "bullet"
        }],
        [{
          'color': []
        }, {
          'background': []
        }],
      ],
      blockPaste: false,
      tooltipVisible: false,
      newEmail: '',
      newExternalLink: '',
      newCompany: '',
      newDeadlineNull: false,
      newName: '',
      renderTimeline: 0,
      gallery: false,
      galleryImg: [],
    };
  },
  beforeMount() {
    this.userInfo = JSON.parse(
      window.localStorage.getItem("mamUserMasterInfo")
    );

    this.getViewTickets();
    this.getFiltersTickets();
  },
  methods: {
    prevImg() {
      const newGalleryImg = this.dataCode.annotations.reduce((newList, obj) => {
        if (obj.textImg !== null) {
          const haveImg = newList.some(havingImg => havingImg.textImg[0] === obj.textImg[0])
          if (!haveImg)
            newList.push(obj);
        }

        return newList
      }, []);
      const currentImg = newGalleryImg.findIndex(obj => obj.textImg === this.galleryImg.textImg);
      if (currentImg > 0) {
        const prevImg = newGalleryImg[currentImg - 1];
        this.galleryImg = prevImg;
      } else if (currentImg === 0)
        this.galleryImg = newGalleryImg[currentImg];
    },
    nextImg() {
      const newGalleryImg = this.dataCode.annotations.reduce((newList, obj) => {
        if (obj.textImg !== null) {
          const haveImg = newList.some(havingImg => havingImg.textImg[0] === obj.textImg[0])
          if (!haveImg)
            newList.push(obj);
        }

        return newList
      }, []);
      const currentImg = newGalleryImg.findIndex(obj => obj.textImg === this.galleryImg.textImg);
      if (currentImg !== -1 && currentImg < newGalleryImg.length - 1) {
        const nextImg = newGalleryImg[currentImg + 1];
        this.galleryImg = nextImg;
      } else if (currentImg !== -1)
        this.galleryImg = newGalleryImg[currentImg];
    },
    openGallery(data) {
      this.galleryImg = data;
      this.gallery = true;
    },
    closeGallery(event) {
      if (event.target.id == 'gallery')
        this.gallery = false;
    },
    copyId() {
      navigator.clipboard.writeText(this.dataCode.companyId)

      this.tooltipVisible = true;
      setTimeout(() => {
        this.tooltipVisible = false
      }, 3000);
    },
    goToFunil() {
      let url = GET_DATA_TO_FUNIL + this.dataCode.companyId;

      REQUEST_SERVICE.requestContext("GET", url, this.dataCode.contextCode)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_DATA_TO_FUNIL:", response.data);

          window.open(
            "/empresa-detalhes-funil/" +
            response.data.pipelineId +
            "/" +
            response.data.id,
            "_blank"
          );
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    modalChangeEmail() {
      this.newEmail = this.dataCode.clientEmail;
      $('#openChangeEmail').modal();
    },
    modalChangeLink() {
      this.newExternalLink = this.dataCode.externalLink;
      $('#openChangeLink').modal();
    },
    modalChangeCompany() {
      this.newCompany = this.dataCode.company;
      $('#openChangeCompany').modal();
    },
    modalChangeName() {
      this.newName = this.dataCode.title;
      $('#openEditName').modal();
    },
    onPaste(event) {
      let paste = (event.clipboardData || window.clipboardData).getData("text");

      if (paste.includes(".svg") ||
        paste.includes(".jpg") ||
        paste.includes(".jpeg") ||
        paste.includes(".gif") ||
        paste.includes(".pdf") ||
        paste.includes(".tiff") ||
        paste.includes(".raw") ||
        paste.includes(".png") ||
        paste === "" ||
        paste === undefined ||
        paste === null
      ) {
        event.preventDefault();
      }
    },
    getViewTickets() {
      let url = VIEW_TICKETS + this.$route.params.ticketId;
      REQUEST_SERVICE.requestContext("GET", url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT VIEW_TICKETS:", response.data);

          this.dataCode = response.data;
          this.dataCode.description = this.dataCode.description.replaceAll("\n", "<br>");
          this.dataCode.annotations.forEach((value) => {
            const rule = /(https?:\/\/[^\s]+)(?:\.png|\.webp|\.svg|\.jpeg|\.jpg)/g;
            const urlIgm = value.text.match(rule);
            value.textImg = urlIgm;
          })

          this.dataCode.tags.map((v, index) => {
            this.loadingRemoveTag.push({
              key: false
            });
          })

          this.dataCode.responsibles.map((v, index) => {
            this.loadingRemoveResponsibles.push({
              key: false
            });
          })

          this.setResultsViewTickets();
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    getViewTicketsPromise() {
      return new Promise((resolve, reject) => {
        let url = VIEW_TICKETS + this.$route.params.ticketId;
        REQUEST_SERVICE.requestContext("GET", url)
          .then((response) => {
            UTIL_SERVICE.console("RESULT VIEW_TICKETS:", response.data);

            this.dataCode = response.data;
            this.dataCode.description = this.dataCode.description.replaceAll("\n", "<br>");

            this.dataCode.tags.map((v, index) => {
              this.loadingRemoveTag.push({
                key: false
              });
            })

            this.dataCode.responsibles.map((v, index) => {
              this.loadingRemoveResponsibles.push({
                key: false
              });
            })

            this.setResultsViewTickets();
            resolve(); // Resolve a promise com sucesso
          })
          .catch((reason) => {
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
            reject(reason); // Rejeita a promise com o motivo do erro
          });
      });
    },
    getFiltersTickets() {
      this.loadingList = true;
      let url = CHANGE_TICKETS_FILTERS;
      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext("GET", url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_TICKETS_FILTERS:", response.data);
          this.listFilters = response.data;
          this.listFilters.stages = this.listFilters.stages.filter((stage) => stage.name !== "Triagem P");
          this.loadingList = false;

          this.setResultsFiltersTickets();
        })
        .catch((reason) => {
          this.loadingList = false;
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    },
    setResultsViewTickets() {
      let changeStage = this.dataCode.ticketStage;
      this.stageSelected = changeStage.id;
    },
    setResultsFiltersTickets() {

      this.dataCode.tags.map((value, index) => {
        this.selectedTags.push(value.id);
      });

      this.listFilters.tags.map((value, index) => {
        this.optionsTags.push({
          id: value.id,
          label: value.name,
        });
      });

      this.dataCode.responsibles.map((value, index) => {
        this.selectedResponsibles.push(value.userMasterId);
      });

      this.listFilters.responsibles.map((value, index) => {
        this.optionsResponsibles.push({
          id: value.id,
          label: value.name,
        });
      });

      if (this.dataCode.deadLine === null) {
        this.newDeadlineNull = true
        this.newDeadlineStr._d = new Date();
      } else {
        this.newDeadlineNull = false
        this.newDeadlineStr = moment(this.dataCode.deadLineStr, 'DD/MM/YYYY')
      }
    },
    changeLink() {
      this.loadingLinkChange = true;

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.dataCode.title,
        description: this.dataCode.description,
        deadLine: this.dataCode.deadLine,
        deadLineStr: this.dataCode.deadLineStr,
        whoCreatedId: this.userInfo.id,
        externalLink: this.newExternalLink,
        clientEmail: this.dataCode.clientEmail,
        responsibleIds: this.selectedResponsibles,
        stageId: this.dataCode.ticketStage.id
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

        this.getViewTicketsPromise().then(() => {
          $('#openChangeLink').modal('hide');
          swal("Aviso", "Link alterado com Sucesso!", "success");
          this.loadingLinkChange = false;

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingLinkChange = false;
        });

      }).catch((reason) => {
        $('#openChangeLink').modal('hide');
        swal("Aviso", reason.response.data, "error");
        this.loadingLinkChange = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    changeName() {
      this.loadingName = true;

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.newName,
        description: this.dataCode.description,
        deadLine: this.dataCode.deadLine,
        deadLineStr: this.dataCode.deadLineStr,
        whoCreatedId: this.userInfo.id,
        externalLink: this.dataCode.externalLink,
        clientEmail: this.dataCode.clientEmail,
        responsibleIds: this.selectedResponsibles,
        stageId: this.dataCode.ticketStage.id
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

        this.getViewTicketsPromise().then(() => {
          $('#openEditName').modal('hide');
          swal("Aviso", "Nome alterado com Sucesso!", "success");
          this.loadingName = false;

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingEmailChange = false;
        });

      }).catch((reason) => {

        $('#openEditName').modal('hide');

        swal("Aviso", reason.response.data, "error");
        this.loadingName = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    changeEmail() {
      this.loadingEmailChange = true;

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.dataCode.title,
        description: this.dataCode.description,
        deadLine: this.dataCode.deadLine,
        deadLineStr: this.dataCode.deadLineStr,
        whoCreatedId: this.userInfo.id,
        externalLink: this.dataCode.externalLink,
        clientEmail: this.newEmail,
        responsibleIds: this.selectedResponsibles,
        stageId: this.dataCode.ticketStage.id
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

        this.getViewTicketsPromise().then(() => {
          $('#openChangeEmail').modal('hide');
          swal("Aviso", "E-mail alterado com Sucesso!", "success");
          this.loadingEmailChange = false;

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingEmailChange = false;
        });

      }).catch((reason) => {

        $('#openChangeEmail').modal('hide');

        swal("Aviso", reason.response.data, "error");
        this.loadingEmailChange = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    changeCompany() {
      this.loadingCompanyChange = true;

      if (!this.$route.params.selectedIdTicket) {
        this.loadingEmailChange = false;
        return swal("Aviso", 'Selecione uma empresa', "error");
      }

      let responsiblesIds = [];

      this.dataCode.responsibles.map((value, index) => {
        responsiblesIds.push(value.userMasterId)
      });

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.dataCode.title,
        description: this.dataCode.description,
        deadLine: this.dataCode.deadLine,
        deadLineStr: this.dataCode.deadLineStr,
        whoCreatedId: this.userInfo.id,
        externalLink: this.dataCode.externalLink,
        clientEmail: this.dataCode.clientEmail,
        responsibleIds: responsiblesIds,
        stageId: this.dataCode.ticketStage.id,
        companyId: this.$route.params.selectedIdTicket
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

        this.getViewTicketsPromise().then(() => {
          $('#openChangeCompany').modal('hide');
          swal("Aviso", "Empresa alterada com Sucesso!", "success");
          this.loadingCompanyChange = false;

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingCompanyChange = false;
        });

      }).catch((reason) => {

        $('#openChangeCompany').modal('hide');
        swal("Aviso", reason.response.data, "error");
        this.loadingCompanyChange = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    changeDeadline(newDeadlineNull) {

      let newDeadline = ''
      let newDeadlineStr = ''

      if (newDeadlineNull) {
        newDeadline = moment(this.newDeadlineStr._d).format()
        newDeadlineStr = moment(this.newDeadlineStr._d).format("DD/MM/YYYY")
      } else {
        newDeadline = this.newDeadlineStr.format()
        newDeadlineStr = this.newDeadlineStr.format("DD/MM/YYYY")
      }

      this.loadingDeadlineEdit = true;

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.dataCode.title,
        description: this.dataCode.description,
        deadLine: newDeadline,
        deadLineStr: newDeadlineStr,
        whoCreatedId: this.userInfo.id,
        externalLink: this.dataCode.externalLink,
        clientEmail: this.dataCode.clientEmail,
        responsibleIds: this.selectedResponsibles,
        stageId: this.dataCode.ticketStage.id
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

        this.getViewTicketsPromise().then(() => {
          $('#openNewDeadline').modal('hide');
          swal("Aviso", "Prazo alterado com Sucesso!", "success");
          this.loadingDeadlineEdit = false;

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingStage = false;
        });

      }).catch((reason) => {

        $('#openNewDeadline').modal('hide');

        swal("Aviso", reason.response.data, "error");
        this.loadingDeadlineEdit = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });

    },
    addTags(value) {
      this.loadingTags = true;

      // let ids = value.map(object => object);
      let oldArrayTags = [];

      this.dataCode.tags.map((value, index) => {
        oldArrayTags.push(value.id);
      });

      const arrayConcat = oldArrayTags.concat(value);
      const formatedIdToObjTag = [...new Set(arrayConcat)];

      let obj = {
        id: this.dataCode.id,
        tagIds: formatedIdToObjTag,
        whoCreatedId: this.userInfo.id,
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TAGS_TICKTS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TAGS_TICKTS:", response.data);

        this.selectedTags = [];
        this.dataCode.annotations = response.data.annotations;

        this.dataCode.tags.map((value, index) => {
          this.selectedTags.push(value.id);
        });

        this.getViewTicketsPromise().then(() => {
          $('#openTags').modal('hide');
          swal("Aviso", "Adicionado com Sucesso!", "success");
          this.loadingTags = false;

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingTags = false;
        });

      }).catch((reason) => {
        swal("Aviso", reason.response.data, "error");
        this.loadingTags = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    removeTags(value, index) {
      this.awaitLoadingRemove = true
      this.loadingRemoveTag[index].key = true

      let obj = {
        id: this.dataCode.id,
        tagIds: this.dataCode.tags.filter(tags => tags.id !== value).map(tags => tags.id),
        whoCreatedId: this.userInfo.id,
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TAGS_TICKTS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TAGS_TICKTS:", response.data);

        this.selectedTags = [];

        this.dataCode.tags.map((value, index) => {
          this.selectedTags.push(value.id);
        });

        this.getViewTicketsPromise().then(() => {
          this.loadingRemoveTag[index].key = false
          this.awaitLoadingRemove = false

          swal({
            icon: 'success',
            title: 'Removido!',
            timer: 1000,
            buttons: false,
          });

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingRemoveTag[index].key = false
          this.awaitLoadingRemove = false
        });


      }).catch((reason) => {
        swal("Aviso", reason.response.data, "error");

        this.loadingRemoveTag[index].key = false
        this.awaitLoadingRemove = false
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });

    },
    removeAllTags() {

      this.loadingTagsRemove = true;

      let obj = {
        id: this.dataCode.id,
        tagIds: [],
        whoCreatedId: this.userInfo.id,
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TAGS_TICKTS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TAGS_TICKTS:", response.data);

        this.selectedTags = [];

        this.dataCode.tags.map((value, index) => {
          this.selectedTags.push(value.id);
        });

        this.getViewTicketsPromise().then(() => {
          $('#openTags').modal('hide');
          swal("Aviso", "Removidos com Sucesso!", "success");
          this.loadingTagsRemove = false;

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingTagsRemove = false;
        });

      }).catch((reason) => {
        swal("Aviso", reason.response.data, "error");
        this.loadingTagsRemove = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    addResponsibles(value) {

      this.loadingResponsibles = true;
      let ids = value.map(object => object);

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.dataCode.title,
        description: this.dataCode.description,
        deadLine: this.dataCode.deadLine,
        whoCreatedId: this.userInfo.id,
        externalLink: this.dataCode.externalLink,
        clientEmail: this.dataCode.clientEmail,
        responsibleIds: ids,
        stageId: this.dataCode.ticketStage.id
      };

      this.dataCode.responsibles.map((value, index) => {
        obj.responsibleIds.push(value.userMasterId);
      });

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

        this.selectedResponsibles = [];

        this.dataCode.responsibles.map((value, index) => {
          this.selectedResponsibles.push(value.userMasterId);
        });

        this.getViewTicketsPromise().then(() => {
          $('#openResponsibles').modal('hide');
          swal("Aviso", "Adicionado com Sucesso!", "success");
          this.loadingResponsibles = false;
        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingResponsibles = false;
        });

      }).catch((reason) => {
        swal("Aviso", reason.response.data, "error");
        this.loadingResponsibles = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    removeResponsibles(value, index) {

      this.awaitLoadingRemove = true
      this.loadingRemoveResponsibles[index].key = true

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.dataCode.title,
        description: this.dataCode.description,
        deadLine: this.dataCode.deadLine,
        whoCreatedId: this.userInfo.id,
        externalLink: this.dataCode.externalLink,
        clientEmail: this.dataCode.clientEmail,
        responsibleIds: this.dataCode.responsibles.filter(responsible => responsible.userMasterId !== value).map(responsible => responsible.userMasterId),
        stageId: this.dataCode.ticketStage.id
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);


        this.selectedResponsibles = [];

        this.dataCode.responsibles.map((value, index) => {
          this.selectedResponsibles.push(value.userMasterId);
        });

        this.getViewTicketsPromise().then(() => {
          swal({
            icon: 'success',
            title: 'Removido!',
            timer: 1000,
            buttons: false,
          });

          $('.swal-title').css('padding-bottom', '40px');
          this.loadingRemoveResponsibles[index].key = false
          this.awaitLoadingRemove = false

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingRemoveResponsibles[index].key = false
          this.awaitLoadingRemove = false
        });

      }).catch((reason) => {
        swal("Aviso", reason.response.data, "error");
        this.loadingTags = false;
        this.loadingRemoveResponsibles[index].key = false
        this.awaitLoadingRemove = false

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    removeAllResponsibles() {

      this.loadingTagsRemove = true;

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.dataCode.title,
        description: this.dataCode.description,
        deadLine: this.dataCode.deadLine,
        whoCreatedId: this.userInfo.id,
        externalLink: this.dataCode.externalLink,
        clientEmail: this.dataCode.clientEmail,
        responsibleIds: [],
        stageId: this.dataCode.ticketStage.id
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

        this.selectedResponsibles = [];

        this.dataCode.responsibles.map((value, index) => {
          this.selectedResponsibles.push(value.userMasterId);
        });

        this.getViewTicketsPromise().then(() => {
          $('#openResponsibles').modal('hide');
          swal("Aviso", "Removidos com Sucesso!", "success");
          this.loadingTagsRemove = false;

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingTagsRemove = false;
        });

      }).catch((reason) => {
        swal("Aviso", reason.response.data, "error");
        this.loadingTagsRemove = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    changeStage(value) {

      this.loadingStage = true;

      let responsibleArray = this.dataCode.responsibles.map(responsible => responsible.userMasterId)

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.dataCode.title,
        description: this.dataCode.description,
        deadLine: this.dataCode.deadLine,
        whoCreatedId: this.userInfo.id,
        externalLink: this.dataCode.externalLink,
        clientEmail: this.dataCode.clientEmail,
        responsibleIds: responsibleArray,
        stageId: value
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

        this.getViewTicketsPromise().then(() => {
          swal("Aviso", " Alterado com Sucesso!", "success");
          this.loadingStage = false;

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingStage = false;
        });

      }).catch((reason) => {
        swal("Aviso", reason.response.data, "error");
        this.loadingStage = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    editDescription() {
      this.toolbarValue = this.dataCode.description.replaceAll("\n", "<br>");

      $('#toolbarDescription').removeClass('display-none');
      $('#boxDescription').addClass('display-none');
    },
    saveEditDescription() {

      this.toolbarValue.replaceAll("\n", "<br>")
      this.loadingDescription = true;

      let responsibleArray = this.dataCode.responsibles.map(responsible => responsible.userMasterId)

      let obj = {
        id: this.dataCode.id,
        ticketProjectId: this.dataCode.ticketProjectId,
        title: this.dataCode.title,
        description: this.toolbarValue,
        deadLine: this.dataCode.deadLine,
        whoCreatedId: this.userInfo.id,
        externalLink: this.dataCode.externalLink,
        clientEmail: this.dataCode.clientEmail,
        responsibleIds: responsibleArray,
        stageId: this.dataCode.ticketStage.id
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.put(UPDATE_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

        this.getViewTicketsPromise().then(() => {
          swal("Aviso", " Descrição alterada com sucesso!", "success");
          this.loadingDescription = false;
          $('#toolbarDescription').addClass('display-none');
          $('#boxDescription').removeClass('display-none');

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingDescription = false;
        });

      }).catch((reason) => {
        swal("Aviso", reason.response.data, "error");
        this.loadingDescription = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);

        $('#toolbarDescription').addClass('display-none');
        $('#boxDescription').removeClass('display-none');
      });
    },
    cancelEditDescription() {

      swal("Aviso", "Cancelado com sucesso!", "success");

      this.toolbarValue = this.dataCode.description.replaceAll("\n", "<br>");

      $('#toolbarDescription').addClass('display-none');
      $('#boxDescription').removeClass('display-none');
    },
    onAddAttachments(e) {
      this.loadingAttach = true;

      let files = e.target.files;
      if (!files.length)
        return;

      let filePromises = [];
      for (let i = 0; i < files.length; i++) {
        let fileAttach = files[i];
        let filePromise = REQUEST_SERVICE.fileUpload(UPLOAD_INFO_PROD, fileAttach);
        filePromises.push(filePromise);
      }

      Promise.all(filePromises)
        .then((responses) => {
          const newAttachments = responses.map((response, index) => {
            return {
              fileUri: response.data,
              fileName: files[index].name,
              id: ''
            };
          });

          const updatedAttachments = [...this.dataCode.attachments, ...newAttachments];

          const timeElapsed = Date.now();
          const today = new Date(timeElapsed);

          let obj = {
            ticketId: this.dataCode.id,
            whoCreatedId: this.userInfo.id,
            attachments: updatedAttachments,
          };

          UTIL_SERVICE.console("Data send: ", obj);
          REQUEST_SERVICE.put(UPDATE_FILE_ATTACHMENTS, obj)
            .then((response) => {
              UTIL_SERVICE.console("RESULT UPDATE_TICKETS:", response.data);

              this.getViewTicketsPromise()
                .then(() => {
                  swal("Aviso", "Anexos adicionados com sucesso!", "success");
                  this.loadingAttach = false;
                  this.getViewTickets();
                })
                .catch((reason) => {
                  swal("Aviso", reason.response.data, "error");
                  this.loadingAttach = false;
                });
            })
            .catch((reason) => {
              swal("Aviso", reason.response.data, "error");
              this.loadingAttach = false;
              ALERT_SERVICE.showMsgError(reason.response.data.erros);
            });
        })
        .catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingAttach = false;
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    },
    removeAttachments(id) {

      let obj = {
        ticketId: this.dataCode.id,
        whoCreatedId: this.userInfo.id,
        attachments: this.dataCode.attachments.filter(attach => attach.id !== id),
      };

      const timeElapsed = Date.now();
      const today = new Date(timeElapsed);
      const removeAtt = this.dataCode.attachments.filter(function (obj) {
        return obj.id == id;
      });

      swal({
        title: "Aviso",
        text: "Você tem certeza que deseja excluir esse anexo?",
        icon: "warning",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: null,
            visible: true,
            className: "",
            closeModal: true,
          },
          confirm: {
            text: "Confirmar",
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        },
        dangerMode: true,
      })
        .then((valueInput) => {
          if (valueInput) {
            UTIL_SERVICE.console("Data send: ", obj);
            REQUEST_SERVICE.put(UPDATE_FILE_ATTACHMENTS, obj).then((response) => {
              UTIL_SERVICE.console("RESULT REMOVE UPDATE_FILE_ATTACHMENTS:", response.data);

              this.getViewTicketsPromise().then(() => {
                swal("Aviso", "Anexo removido com sucesso!", "success");
                this.getViewTickets();

              }).catch((reason) => {
                swal("Aviso", reason.response.data, "error");
              });


            }).catch((reason) => {
              swal("Aviso", reason.response.data, "error");
              ALERT_SERVICE.showMsgError(reason.response.data.erros);
            });
          }
        })
    },
    backTickets() {
      window.location.href = "/tickets";
    },
    addAnnotation(value) {

      if (this.newAnnotation === '') {
        swal("Aviso", "Não é possivel enviar uma observação vazia!", "warning");
        return
      }

      value = value.replaceAll("\n", "<br>");
      this.loadingAnnotation = true;

      let obj = {
        ticketId: this.dataCode.id,
        whoCreatedId: this.userInfo.id,
        annotations: [{
          text: value,
        }],
      };

      UTIL_SERVICE.console("Data send: ", obj);
      REQUEST_SERVICE.post(CREATE_ANNOTATION_TICKETS, obj).then((response) => {
        UTIL_SERVICE.console("RESULT CREATE_ANNOTATION_TICKETS:", response.data);

        this.getViewTicketsPromise().then(() => {
          swal("Aviso", "Adicionado com Sucesso!", "success");
          this.loadingAnnotation = false;
          this.newAnnotation = '';

        }).catch((reason) => {
          swal("Aviso", reason.response.data, "error");
          this.loadingAnnotation = false;
        });

      }).catch((reason) => {
        swal("Aviso", reason.response.data, "error");
        this.loadingAnnotation = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    customFormatterTicket(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="scss">

$classic-white: #FFFFFF;
$classic-black: #343434;
$classic-input: #EEF2F7;
$classic-border: #E6E9EC;
$classic-grey: #7F8897;
$button-grey: #D5DFEB;
$light-grey: #969696;
$light-grey-hover: #5F6B80;
$light-black: #3A424E;
$light-blue: #2F23D6;
$light-blue-hover: #251BAD;
$light-black: #3A424E;
$light-purple: #A313BB;
$light-pink: #FF2CC4;
$light-orange: #FF9900;
$light-yellow: #F9CA04;
$light-red: #FF445D;
$light-red-hover: #FF1737;
$light-green: #2ACC6B;
$light-green-hover: #3FB55E;
$light-green-yellow: #A1E80A;
$light-cyan: #00B6DE;
$border-grey: #BACADC;
$bg-grey: #EEF2F7;
$input-hover: #D5DFEB;

$colors: (classic-white: #FFFFFF !important,
  classic-input: #EEF2F7 !important,
  light-grey: #969696 !important,
  light-black: #3A424E !important,
  light-blue: #2F23D6 !important,
  light-purple: #A313BB !important,
  light-pink: #FF2CC4 !important,
  light-orange: #FF9900 !important,
  light-red: #FF445D !important,
  light-green: #2ACC6B !important,
  light-cyan: #00B6DE !important,
  //stages
  stage-blue: #D5F7FF !important,
  stage-green: #B6FFC6 !important,
  stage-red: #FFD9D9 !important,
  stage-yellow: #FFFCBF !important,
);

.gallery-box {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  background: rgba(0, 0, 0, .4);
  width: 100vw;
  height: 100vh;
  padding: 40px;

  ul {
    list-style: none;
    display: flex;
    margin: 60px auto;
    padding: 0;
    justify-content: center;
    position: relative;
    height: 800px;

    li {
      margin: auto 0;

      img {
        border-radius: 20px !important;
        max-width: 1260px;
        min-width: 400px;
        max-height: 800px;
      }
    }

    button {
      position: absolute;
      background: none;
      border: none;
      top: -80px;
      z-index: 5;

      ion-icon {
        font-size: 36px;
        opacity: .7;
        color: #fff;

        &:hover {
          opacity: 1;
        }
      }
    }
  }

  .gallery-control {
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: absolute;
    padding: 0 120px;
    left: 0;
    top: 50%;

    button {
      background: #fff;
      border: none;
      border-radius: 5px !important;
      padding: 18px 8px 14px 8px;
      z-index: 5;

      &:hover {
        background: #e9e9e9;
      }

      &:active {
        background: #fff;
      }
    }
  }
}

@media (max-width: 1600px) {
  .gallery-box {
    ul {
      li {
        img {
          max-width: 900px;
        }
      }
    }
  }
}

@media (max-width: 1220px) {
  .gallery-box {
    ul {
      li {
        img {
          max-width: 600px;
        }
      }
    }
  }
}

.bg-description {
  background: #2CF0CD;
}

@mixin gen-props($prefix, $property) {

  @each $color-name,
  $color in $colors {
    .#{$prefix}-#{$color-name} {
      #{$property}: $color
    }
  }
}

@include gen-props("border", "border-color");
@include gen-props("text", "color");
@include gen-props("bg", "background");

@-webkit-keyframes rotate-tag {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes rotate-tag {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-ms-keyframes rotate-tag {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes rotate-tag {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotate-tag {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.checkbox {
  margin-left: 0;
}

.container-fluid {
  padding-left: 25%;
  padding-right: 25%;
}

.swal-overlay {
  z-index: 30000;
}

.ion-autocomplete-selected {
  right: 0px !important;
  top: -1px !important;
}

@media only screen and (max-width: 1600px) {
  .container-fluid {
    padding-left: 15% !important;
    padding-right: 15% !important;
  }
}

@media only screen and (max-width: 1000px) {
  .container-fluid {
    padding-top: 2% !important;
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}

.div-spans {
  margin: 20px 0;

  .subtitle-span {
    font-weight: 400;
    font-size: 14px;
    color: #191919;
  }

  .btn-remove-all {
    float: right;
    margin: 0 0 0 1.3rem;
    padding: 4px 20px;
    border: 1px solid $light-red;
    border-radius: 4px !important;
    font-size: 14px;
    font-weight: 500;
    color: $light-red;
    background-color: $classic-white;

    .span-remove-tags {
      color: $light-red;
    }

    .loading-btn {
      .spinner-btn {
        width: 30px;
        height: 15px;
        margin: 2.5px 39px;

        div {
          margin: 0;
          width: 2px;
          background-color: $light-red !important;
        }
      }
    }

    &:hover {
      border: 1px solid $light-red-hover;
      background-color: $light-red;

      .span-remove-tags {
        color: $classic-white;
      }

      .loading-btn {
        .spinner-btn {
          div {
            background-color: $classic-white !important;
          }
        }
      }
    }
  }

  .tags-group {
    margin: 25px 0 0 0;

    button {
      color: $classic-white;
      padding: 0;
      border: none;
      background: transparent;

      ion-icon {
        display: inline-flex;
        width: 18px;
        height: 18px;
        vertical-align: text-top;
        margin-top: 1px;
      }
    }

    .icon-loading {
      color: $classic-white;
      display: inline-flex;
      width: 18px;
      height: 18px;
      vertical-align: sub;

      -webkit-animation: rotate-tag 3s linear alternate 3;
      -moz-animation: rotate-tag 3.0s linear infinite;
      -ms-animation: rotate-tag 3.0s linear infinite;
      -o-animation: rotate-tag 3.0s linear infinite;
      animation: rotate-tag 3.0s linear infinite;
    }
  }

  .ticket-tags {
    font-size: 14px;
    font-weight: 500;
    padding: 3px 5px;
    border-radius: 4px !important;
    display: inline-block;
    text-align: center;
    margin: 2px;

    span {
      color: $classic-white;
    }
  }
}

.modal-dialog {
  width: 35% !important;

  .modal-content {
    border: none;

    .default-box-modal {
      background-color: #FFFFFF;
      padding: 25px 20px 25px;
      margin-top: 0;
      margin-bottom: 25px;
      border-radius: 8px !important;

      .input-data {
        width: 100%;

        .ion-calendar {
          visibility: visible !important;
          position: absolute;
          top: 55%;
          cursor: pointer;
          right: 67%;
        }
      }

      .div-add-tags {
        display: inline-flex;
        width: 100%;
        height: 4rem !important;

        .vue2-multi-select-wrap {
          width: 100% !important;
        }

        .vue2-multi-select {
          cursor: auto;
          background-color: $bg-grey !important;
          border: 1px solid $bg-grey !important;
          border-radius: 4px !important;

          &:hover {
            border: 1px solid $input-hover !important;
          }

          .vue2-value-items {
            z-index: 1 !important;
          }
        }

        .vue2-placeholder {
          z-index: 1 !important;
          color: $classic-black !important;
          font-size: 14px !important;
          font-weight: 400 !important;
        }

        .btn-add-tags {
          margin: 0 0 0 1.3rem;
          padding: 0 20px;
          border: 1px solid $light-green;
          border-radius: 4px !important;
          font-size: 14px;
          font-weight: 500;
          color: $light-green;
          background-color: $classic-white;

          .span-save-tags {
            color: $light-green;
          }

          .loading-btn {
            .spinner-btn {
              width: 30px;
              height: 15px;
              margin-left: 1px;

              div {
                margin: 0;
                width: 2px;
                background-color: $light-green !important;
              }
            }
          }

          &:hover {
            border: 1px solid $light-green-hover;
            background-color: $light-green;
            color: $classic-white;

            .span-save-tags {
              color: $classic-white;
            }

            .loading-btn {
              .spinner-btn {
                div {
                  background-color: $classic-white !important;
                }
              }
            }
          }
        }
      }

      span {
        font-size: 14px;
        font-weight: 400;
        color: $classic-grey;
      }

      .div-spans {
        margin: 20px 0 0 0;

        .subtitle-span {
          color: $classic-black;
        }

        .btn-remove-all {
          float: right;
          margin: 0 0 0 1.3rem;
          padding: 4px 20px;
          border: 1px solid $light-red;
          border-radius: 4px !important;
          font-size: 14px;
          font-weight: 500;
          color: $light-red;
          background-color: $classic-white;

          .span-remove-tags {
            color: $light-red;
          }

          .loading-btn {
            .spinner-btn {
              width: 30px;
              height: 15px;
              margin: 2.5px 39px;

              div {
                margin: 0;
                width: 2px;
                background-color: $light-red !important;
              }
            }
          }

          &:hover {
            border: 1px solid $light-red-hover;
            background-color: $light-red;

            .span-remove-tags {
              color: $classic-white;
            }

            .loading-btn {
              .spinner-btn {
                div {
                  background-color: $classic-white !important;
                }
              }
            }
          }
        }
      }

      .tags-group {
        margin: 25px 0 0 0;

        button {
          color: $classic-white;
          padding: 0;
          border: none;
          background: transparent;

          ion-icon {
            display: inline-flex;
            width: 18px;
            height: 18px;
            vertical-align: text-top;
            margin-top: 1px;
          }
        }

        .icon-loading {
          color: $classic-white;
          display: inline-flex;
          width: 18px;
          height: 18px;
          vertical-align: sub;

          -webkit-animation: rotate-tag 3s linear alternate 3;
          -moz-animation: rotate-tag 3.0s linear infinite;
          -ms-animation: rotate-tag 3.0s linear infinite;
          -o-animation: rotate-tag 3.0s linear infinite;
          animation: rotate-tag 3.0s linear infinite;
        }

      }

      select {
        margin-bottom: 10px;
        border-bottom-left-radius: 4px !important;
        border-top-left-radius: 4px !important;
        height: 34px !important;
        border: 1px solid #EEF2F7 !important;

        &:hover {
          border: 1px solid $light-grey-hover !important;
        }
      }

      .ticket-tags {
        font-size: 14px;
        font-weight: 500;
        padding: 3px 5px;
        border-radius: 4px !important;
        display: inline-block;
        text-align: center;
        margin: 2px;

        span {
          color: $classic-white;
        }
      }

      .ticket-responsible {
        font-size: 14px;
        font-weight: 500;
        padding: 3px 5px;
        border-radius: 4px !important;
        display: inline-block;
        text-align: center;
        margin: 2px;
        background-color: #969696;

        span {
          color: $classic-white;
        }
      }

      .input-with-date-filter {
        label {
          font-size: 14px;
          font-weight: 400;
          color: #7F8897;
        }

        .inputs-group {
          display: flex;
          align-items: baseline;
          justify-content: space-between;

          .inputs-group-first {
            width: 100%;
            position: relative;

            border: 1px solid #EEF2F7;
            border-radius: 4px;

            &:hover {
              border-radius: 4px !important;
              border: 1px solid #D5DFEB !important;
            }

            .vdp-datepicker {
              border-radius: 4px !important;
            }

            ion-icon {
              position: absolute;
              top: 1rem;
              right: 1rem;
              font-size: 18px
            }

            .input-email {
              padding: 0.6rem 1.2rem;
              height: 34px !important;
              color: #343434 !important;
              border: 1px solid #EEF2F7 !important;
              border-top-left-radius: 4px !important;
              border-bottom-left-radius: 4px !important;
              background-color: #EEF2F7 !important;

              &:focus,
              &:hover {
                outline: none !important;
                border: 1px solid $button-grey !important;
              }
            }
          }

          .span-edit-deadline {
            width: 2.5rem;
            font-size: 18px;
            font-weight: 600;
            margin-left: .5rem;
            color: #2F23D6;
          }

          .inputs-group-second {
            display: flex;
            align-items: baseline;

            width: 40%;
            position: relative;
            border: 1px solid #EEF2F7;
            border-radius: 4px;
            background: #EEF2F7 !important;

            &:hover {
              border-radius: 4px !important;
              border: 1px solid #D5DFEB !important;
            }

            .input-hour {
              width: 75%;
            }

            ion-icon {
              position: absolute;
              top: 1rem;
              right: 1rem;
              font-size: 18px;
            }
          }
        }

        .btn-group {
          float: right;

          .btn-save {
            padding: 0 20px;
            border: 1px solid #2ACC6B;
            border-radius: 4px !important;
            font-size: 14px;
            font-weight: 600;
            color: #2ACC6B;
            background-color: #FFFFFF;
            height: 40px;
            margin-top: 1rem;

            &:hover {
              background: #2ACC6B !important;
              color: #FFFFFF !important;
            }
          }

          .btn-cancel {
            padding: 0 20px;
            border: 1px solid #D5DFEB !important;
            border-radius: 4px !important;
            font-size: 14px;
            font-weight: 600;
            color: #3A424E !important;
            background-color: #D5DFEB;
            height: 40px;
            margin-top: 1rem;

            &:hover {
              border: 1px solid #AEB5BE !important;
              background-color: rgba(174, 181, 190, 0.99);
            }
          }

          .btn-save-deadline {
            margin: 1rem 0 0 0;
            padding: 4px 26px;
            border: 1px solid $light-green;
            border-radius: 4px !important;
            font-size: 14px;
            font-weight: 500;
            color: $light-green;
            background-color: $classic-white;

            .span-save-deadline {
              color: $light-green;
            }

            .loading-btn {
              .spinner-btn {
                width: 40.8px;
                height: 20px;
                margin-left: 1px;

                div {
                  margin: 0 0 -2px 0;
                  width: 2px;
                  background-color: $light-green !important;
                }
              }
            }

            &:hover {
              border: 1px solid $light-green-hover;
              background-color: $light-green;
              color: $classic-white;

              .span-save-deadline {
                color: $classic-white;
              }

              .loading-btn {
                .spinner-btn {
                  div {
                    background-color: $classic-white !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.modal-dialog-deadline {
  width: 20% !important;
}

.modal-dialog-email {
  width: 30% !important;
}

.modal-dialog-link {
  width: 30% !important;
}

@media only screen and (max-width: 1490px) {
  .modal-dialog-responsibles {
    width: 45% !important;
  }

  .modal-dialog-tags {
    width: 45% !important;
  }
}

@media only screen and (max-width: 1175px) {
  .modal-dialog-responsibles {
    width: 55% !important;
  }

  .modal-dialog-tags {
    width: 55% !important;
  }
}

@media only screen and (max-width: 929px) {
  .modal-dialog-responsibles {
    width: 65% !important;
  }

  .modal-dialog-tags {
    width: 65% !important;
  }
}

.v-tooltip {
  background-color: blue;
  color: white;
  padding: 5px;
}

.ticket-list-content {

  .ticket-title {
    display: block;

    .ticket-span-title {
      padding-right: 90px;
      margin: 0 !important;
      font-size: 24px !important;
      font-weight: 600 !important;
      color: $classic-black !important;

      a {
        ion-icon {
          color: #969696;
          font-size: 30px;
          margin-left: 5px;
          vertical-align: top;

          &:hover {
            color: #5F6B80;
          }
        }
      }
    }

    .ticket-span-subtitle {
      margin: .5rem 0 !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      color: $light-grey !important;
    }

    .back-tickets {
      position: absolute;
      top: 0;
      right: 15px;

      display: flex;
      align-items: center;
      font-size: 21px;
      font-weight: 500;
      color: var(--high-blue);
      cursor: pointer;

      ion-icon {
        margin-right: 5px;
        font-size: 28px;
      }

      &:hover {
        color: #241B9C;
      }
    }

    hr {
      border-top: 2px solid $classic-border !important;
    }
  }

  .ticket-details {
    display: block;

    .ticket-card {
      padding: 0;
      display: block;
      min-height: 130px;
      margin: 2.5rem 0;

      .label-icon {
        display: flex;
        align-items: center;
        height: 25px;
      }

      .ticket-owner {
        font-size: 18px !important;
        font-weight: 400 !important;

        span {
          color: $classic-black !important;
          font-weight: 500 !important;
          display: inline-flex;
          vertical-align: middle;
          margin-right: 8px;
          padding: 0 .5rem 0 0;
        }

        button {
          padding: .5rem 1.5rem .5rem 1.5rem;
          border: 1px solid $button-grey !important;
          border-radius: 4px !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: $light-black;
          background-color: $button-grey;

          &:hover {
            border: 1px solid #AEB5BE !important;
            background-color: rgba(174, 181, 190, 0.99);
          }

          ion-icon {
            display: inline-flex;
            width: 16px;
            height: 20px;
            font-size: 16px;
            vertical-align: bottom;
            margin-right: .4rem;
          }
        }

        .ticket-responsible {
          font-size: 18px;
          font-weight: 500;
          padding: 3px 10px;
          border-radius: 4px !important;
          display: inline-block;
          text-align: center;
          margin: 2px;
          background-color: #969696 !important;
          color: $classic-white !important;
        }

      }

      .ticket-company {
        display: flex;
        align-items: center;

        .ticket-span-company {
          font-size: 18px;
          font-weight: 500;
          padding: 3px 5px;
          border-radius: 4px !important;
          text-align: center;
          margin: .2rem;
          color: #FFFFFF;
          background-color: $light-blue;
          cursor: pointer;
        }

        .copy-id {
          position: relative;
          font-size: 24px;
          margin-left: 8px;
          cursor: pointer;

          ion-icon {
            pointer-events: none;
          }

          span {
            position: absolute;
            top: 5px;
            right: -70px;
            font-size: 11px;
            color: #2F23D6;
            cursor: context-menu;
          }
        }

        button {
          margin: 0 0 0 1.3rem;
          padding: .5rem 1.5rem .5rem 1.5rem;
          border: 1px solid $button-grey !important;
          border-radius: 4px !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: $light-black !important;
          background-color: $button-grey;

          &:hover {
            border: 1px solid #AEB5BE !important;
            background-color: rgba(174, 181, 190, 0.99);
          }

          ion-icon {
            display: inline-flex;
            width: 16px;
            height: 20px;;
            font-size: 16px;
            vertical-align: bottom;
            margin-right: .4rem;
          }
        }
      }

      .ticket-stage {
        select {
          width: 40%;
          padding: .6rem 1.2rem;
          height: 34px !important;
          color: $classic-black !important;
          border: 1px solid $classic-input !important;
          border-top-left-radius: 4px !important;
          border-bottom-left-radius: 4px !important;
          background-color: $classic-input !important;

          &:focus,
          &:hover {
            outline: none !important;
            border: 1px solid $button-grey !important;
          }
        }

        button {
          margin: 0 0 0 1.3rem;
          padding: 4px 20px;;
          border: 1px solid $light-green !important;
          border-radius: 4px !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: $light-green !important;
          background-color: $classic-white;

          &:hover {
            border: 1px solid $light-green-hover !important;
            background-color: $light-green !important;
            color: $classic-white !important;
          }

          ion-icon {
            display: inline-flex;
            width: 20px;
            height: 20px;;
            font-size: 16px;
            vertical-align: bottom;
            margin-right: .4rem;
          }
        }

        .btn-save {
          margin: 0 0 0 1.3rem;
          padding: 4px 25px;
          border: 1px solid $light-green;
          border-radius: 4px !important;
          font-size: 14px;
          font-weight: 500;
          color: $light-green;
          background-color: $classic-white;

          .span-save {
            color: $light-green;
          }

          .loading-btn {
            .spinner-btn {
              width: 69.5px;
              height: 20px;
              margin-left: 1px;

              div {
                margin: 0 0 -2px 0;
                width: 2px;
                background-color: $light-green !important;
              }
            }
          }

          &:hover {
            border: 1px solid $light-green-hover;
            background-color: $light-green;
            color: $classic-white;

            .span-save {
              color: $classic-white;
            }

            .loading-btn {
              .spinner-btn {
                div {
                  background-color: $classic-white !important;
                }
              }
            }
          }
        }
      }

      .ticket-deadline {
        .title-deadline {
          font-size: 18px;
          font-weight: 800;
          color: $classic-black !important;
        }
      }

      .ticket-paragraph {
        font-size: 18px;
        font-weight: 800;
        color: #343434 !important;
        margin-top: 0;
        word-break: break-word;

        a {
          font-weight: 500;
          color: #337AB7;
        }
      }
    }

    .button-circle {
      vertical-align: middle;
      color: $light-grey;
      cursor: pointer;
      margin-left: 5px;
      font-size: 30px;

      &:hover {
        color: $light-grey-hover;
      }
    }

    .button-edit {
      vertical-align: middle;
      color: $light-grey;
      cursor: pointer;
      margin-left: 5px;
      font-size: 30px;

      &:hover {
        color: $light-grey-hover;
      }
    }


    .ticket-card-details {
      display: inline-table;
      padding: 0;
      min-height: 130px;
      margin-bottom: 2.5rem;

      .label-icon {
        display: flex;
        align-items: center;
        height: 25px;
      }

      label {
        display: block;
      }

      .title-details {
        font-size: 18px;
        font-weight: 800;
        color: $light-blue !important;

        .ticket-is-late {
          font-size: 14px !important;
          font-weight: 500;
          padding: 2px 8px;
          border-radius: 4px !important;
          text-align: center;
          margin: 2px;
          color: $classic-white;
          background: $light-red;
        }
      }

      .ticket-tags {
        font-size: 14px;
        font-weight: 500;
        padding: 3px 5px;
        border-radius: 4px !important;
        display: inline-block;
        text-align: center;
        margin: 2px;
        color: $classic-white;
      }
    }

    .ticket-card-details-two {
      //margin-left: 5rem;
    }

    hr {
      border-top: 2px solid $classic-border !important;
    }
  }

  .ticket-info {
    .ticket-card {
      display: block;
      width: 100%;
      margin: 2.5rem 0;

      label {
        color: $classic-black;
        font-size: 14px;
        font-weight: 800;

        span {
          ion-icon {
            display: inline-flex !important;
            width: 22px !important;
            height: 32px !important;
            vertical-align: bottom !important;
            margin-right: .2rem !important;
          }
        }
      }

      .ticket-label-attach {
        color: $classic-black;
        font-size: 14px;
        font-weight: 800;

        span {
          margin-bottom: 10px;

          ion-icon {
            margin: 0 !important;
            display: inline-flex !important;
            width: 20px !important;
            height: 20px !important;
          }
        }

        .span-attachments {
          font-size: 14px;
          font-weight: 500;
          color: $light-blue !important;

          ion-icon {
            padding: 10px 5px 0 0 !important;
            color: $classic-grey;
          }
        }

        .span-attachments-else {
          font-size: 14px;
          font-weight: 500;
          color: $classic-black !important;

          ion-icon {
            padding: 10px 5px 0 0 !important;
            color: $classic-grey;
          }
        }

        .close-circle-button {
          cursor: pointer;
          color: $light-red !important;

          &:hover {
            color: $light-red-hover !important;
          }
        }
      }

      .button-add-attachments {
        margin: 1.5rem 0 0 0;
        padding: 7px 23px 7px 23px;;

        ion-icon {
          width: 20px !important;
        }
      }

      .button-wrapper {
        width: 166px;
        margin-top: 15px;

        label {
          border-radius: 4px !important;
          position: relative;
          z-index: 0;
          display: inline-block;
          width: 100%;
          background: $button-grey;
          border: 1px solid $button-grey;
          cursor: pointer !important;
          color: $light-black;
          padding: 10px 0;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 0;

          #uploadAttach {
            position: absolute;
            z-index: 1;
            width: 166px;
            height: 40px;
            top: 87.9%;
            opacity: 0;
            cursor: pointer !important;
            pointer-events: none;
          }

          ion-icon {
            display: inline-flex !important;
            width: 20px !important;
            height: 20px !important;
            vertical-align: text-bottom !important;
            cursor: pointer !important;
          }
        }

        .loading-btn {
          .spinner-btn {
            div {
              height: 20px !important;
              background-color: $light-black !important;
            }
          }
        }

        &:hover {
          label {
            background: #AEB5BE !important;
            border: 1px solid #AEB5BE;
            cursor: pointer !important;
          }
        }
      }

      button {
        margin: 0 0 0 1.3rem;
        padding: .5rem 1.5rem .5rem 1.5rem;
        border: 1px solid $button-grey !important;
        border-radius: 4px !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        color: $light-black !important;
        background-color: $button-grey;

        &:hover {
          border: 1px solid #AEB5BE !important;
          background-color: rgba(174, 181, 190, 0.99);
        }

        ion-icon {
          display: inline-flex !important;
          width: 16px !important;
          height: 20px !important;
          vertical-align: bottom !important;
          margin-right: .4rem !important;
        }
      }

      textarea {
        cursor: auto;
        padding: 1rem;
        height: 32rem;
        margin: .5rem 0 0 0;
        font-size: 14px;
        font-weight: 400;
        color: $light-black !important;
        resize: none;
        border: 1px solid $border-grey !important;
        border-radius: 4px !important;
        background-color: $classic-border;
        min-width: 100% !important;
        max-width: 100% !important;
        min-height: 32rem !important;
        max-height: 32rem !important;
      }

      .box-description {
        word-break: break-word !important;
        margin: 20px 0 0 0 !important;
        background-color: #EEF2F7;
        height: 32rem;
        width: 100%;
        border-radius: 4px !important;
        border: 1px solid $border-grey !important;
        overflow-y: auto;

        div {
          padding: 12px 15px;
          font-size: 16px;
          font-weight: 400;

          p {
            margin: 0;
            padding: 0;
            color: $light-black !important;
          }

          ol {
            margin: 0;
            padding-left: 4.5rem !important;
          }

          ul {
            margin: 0;
            padding-left: 5.5rem !important;
          }
        }
      }

      .custom-toolbar-description {
        margin: 20px 0 50px 0 !important;
        background: #EEF2F7 !important;

        .ql-toolbar {
          border: 1px solid #BACADC !important;
          border-bottom: none !important;
          border-top-left-radius: 4px !important;
          border-top-right-radius: 4px !important;
          background: #D5DFEB !important;
          padding: 4px !important;

          .ql-formats {
            margin: 5px 0 5px 20px !important;

            button {
              margin: 0 !important;
              padding: 0 !important;
              border: none !important;
              font-size: 18px !important;
              font-weight: 600 !important;
              color: #191919 !important;
              background-color: transparent !important;
            }

            .ql-strike {
              margin-right: 5rem !important;
            }

            .ql-list {
            }

            .ql-color {
              padding-top: 1px;
              margin-left: 5rem;
            }

            .ql-picker {
              top: 0 !important;

              .ql-picker-label {
                padding: 0 !important;
                border: none !important;
              }
            }
          }
        }

        .ql-container {
          border: 1px solid #BACADC !important;
          border-top: none !important;
          border-bottom-left-radius: 4px !important;
          border-bottom-right-radius: 4px !important;
        }

        .ql-editor {
          min-height: 32rem !important;
          max-height: 32rem !important;

          ul {
            li:not(.ql-direction-rtl) {
              padding-left: 0;
            }
          }
        }

        .btn-save-description {
          margin-top: 10px !important;
          float: right !important;
          height: 3.6rem !important;
          width: 18rem !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          border: 1px solid #2ACC6B !important;
          background: #FFFFFF !important;
          color: #2ACC6B !important;

          ion-icon {
            margin-right: 0 !important;
            width: 18px !important;
          }

          .loading-btn {
            .spinner-btn {
              div {
                background: #2ACC6B !important;
                height: 20px !important;
              }
            }
          }

          &:hover {
            background: #2ACC6B !important;
            color: #FFFFFF !important;

            .loading-btn {
              .spinner-btn {
                div {
                  background: #FFFFFF !important;
                  height: 20px !important;
                }
              }
            }
          }
        }

        .btn-cancel-description {
          margin-top: 10px !important;
          float: right !important;
          height: 3.6rem !important;
        }
      }
    }
  }

  .ticket-history {
    .ticket-card {
      display: block;
      width: 100%;
      margin: 2.5rem 0 0 0;

      .title-history {
        color: #343434;
        font-size: 14px;
        font-weight: 800;

        span {
          display: flex;
          align-items: center;
          gap: 4px;

          ion-icon {
            width: 22px !important;
            height: 32px !important;
            vertical-align: bottom !important;
            margin-right: 0.2rem !important;
          }
        }

        button {
          margin: 0 0 0 2rem;
          padding: 4px 10px 4px 10px;
          border: 1px solid #D5DFEB !important;
          border-radius: 4px !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #3A424E !important;
          background-color: #D5DFEB;

          ion-icon {
            display: inline-flex !important;
            width: 20px !important;
            height: 20px !important;
            vertical-align: sub !important;
            margin-right: 0.2rem !important;
          }

          &:hover {
            border: 1px solid #AEB5BE !important;
            background-color: rgba(174, 181, 190, 0.99);
          }
        }

      }

      .toolbar-history {
        width: 95%;
        height: 20rem;
        background: #EEF2F7 !important;
        margin-bottom: -18px;

        .ql-toolbar {
          border: 1px solid #BACADC !important;
          border-bottom: none !important;
          border-top-left-radius: 4px !important;
          border-top-right-radius: 4px !important;
          background: #D5DFEB !important;
          padding: 4px !important;

          .ql-formats {
            margin: 5px 0 5px 20px !important;

            button {
              margin: 0 !important;
              padding: 0 !important;
              border: none !important;
              font-size: 18px !important;
              font-weight: 600 !important;
              color: #191919 !important;
              background-color: transparent !important;
            }

            .ql-strike {
              margin-right: 5rem !important;
            }

            .ql-list {
            }

            .ql-color {
              padding-top: 1px;
              margin-left: 5rem;
            }

            .ql-picker {
              top: 0 !important;

              .ql-picker-label {
                padding: 0 !important;
                border: none !important;
              }
            }
          }
        }

        .ql-container {
          height: 79%;
          border-radius: 0 0 5px 5px !important;

          .ql-editor {
            min-height: 156px !important;
            max-height: 156px !important;

            ul {
              li:not(.ql-direction-rtl) {
                padding-left: 0;
              }
            }
          }
        }
      }

      .send-history-line {
        display: flex;
        position: relative;

        .input-add-history {
          max-width: 94.5%;
          min-width: 94.5%;
          min-height: 150px;
          max-height: 150px;
          margin: 1.5rem 1rem 0 0;
          border: 1px solid #EEF2F7 !important;
          border-radius: 4px !important;
          resize: none;

          &:hover {
            border: 1px solid #D5DFEB !important;
          }
        }

        .button-attach-history {
          visibility: visible;
          height: 65px;
          width: 30px;
          position: absolute;
          cursor: pointer;
          right: 7%;
          color: $light-grey !important;
        }

        button {
          background-color: $light-blue !important;
          border: 1px solid $light-blue !important;
          border-radius: 4px !important;
          width: 36px;
          height: 34px;
          margin: 15px 0 0 0;
          position: absolute;
          bottom: -18px;
          right: 0;

          &:hover {
            background-color: $light-blue-hover !important;
            border: 1px solid $light-blue-hover !important;
          }

          ion-icon {
            color: $classic-white;
            width: 22px !important;
            height: 32.5px !important;
          }

          .loading-btn {
            .spinner-btn {
              div {
                margin-right: 0;
                width: 3px;
                height: 8px;
              }
            }
          }

        }
      }

      .box-history-timeline {
        margin: 20px 0 0 0 !important;
        background-color: $classic-border;
        height: 65rem;
        width: 100%;
        border-radius: 4px !important;
        border: 1px solid $border-grey !important;
        overflow-y: auto;

        .nav-timeline {
          display: flex;
          align-items: flex-end;
          height: 49px;
          padding: 0 20px;
          background: #fff;

          p {
            margin: 0 0 4px 0;
            padding: 0 12px 4px 12px;

            &:nth-child(2) {
              span {
                position: relative;

                &:before, &:after {
                  content: '';
                  display: block;
                  width: 1px;
                  height: 16px;
                  background: rgba(0, 0, 0, .2);
                  position: absolute;
                  top: 3px;
                  left: -12px;
                }

                &:after {
                  left: 128px;
                }
              }
            }

            span {
              font-size: 18px;
              cursor: pointer;
              padding-bottom: 4px !important;
            }

            &:hover, .active {
              color: #2f23d6;

              &:after {
                content: '';
                display: flex;
                margin: 4px -10% -8px -10%;
                height: 4px;
                background: #2f23d6;
                width: 120%;
                border-radius: 4px 4px 0 0;
                box-sizing: border-box;
              }
            }
          }

          .active {
            color: #2f23d6;

            &:after {
              content: '';
              display: flex;
              margin: 4px -10% -8px -10%;
              height: 4px;
              background: #2f23d6;
              width: 120%;
              border-radius: 4px 4px 0 0;
              box-sizing: border-box;
            }
          }
        }

        .general-timeline {
          margin: 30px 0 30px 30px;
          max-width: 100%;
          position: relative;

          label {
            color: $light-blue !important;
            font-size: 16px !important;
            font-weight: 600;
          }

          .comment-timeline-content {
            background-color: $classic-white;
            width: fit-content;
            max-width: 97%;
            padding: 5px 10px 10px 10px;
            border-radius: 4px !important;

            .date-comment {
              color: $classic-grey !important;
              font-size: 11px !important;
              font-weight: 400;
              margin: 0;
            }

            .comment-content {
              word-break: break-word;
              font-size: 14px;
              font-weight: 500;
              color: $light-black !important;
              margin: 5px 0 0 0;

              p {
                margin: 0 !important;
              }

              li {
                margin-left: 20px;
              }
            }
          }

          .content-general {
            width: 97%;
            padding: 5px 10px 5px 10px;
            border-radius: 4px !important;
            display: inline-flex;
            justify-content: space-between;

            .img-view {
              margin-top: 6px;
              padding-bottom: 4px;

              img {
                width: 100px;
                border-radius: 5px !important;
                object-fit: contain;
                cursor: pointer;
                transition: transform .2s ease-in;

                &:hover {
                  transform: scale(1.1);
                }
              }
            }

            .stage-content-general {
              margin: 0;
              font-size: 14px;
              font-weight: 400;

              b {
                font-size: 14px;
                font-weight: 700;
                margin: 0;
              }
            }

            .date-stage-general {
              font-size: 11px !important;
              color: $classic-grey !important;
              font-weight: 400;
              display: flex;
              float: right;
              padding: 3px 0 0 0;
            }
          }

          //.attachments-timeline-content {
          //  background-color: #D4F7FF;
          //  width: 97%;
          //  padding: 5px 10px 5px 10px;
          //  border-radius: 4px !important;
          //  display: inline-flex;
          //  justify-content: space-between;
          //
          //
          //  .attachments-content {
          //    margin: 0;
          //    font-size: 14px;
          //    font-weight: 400;
          //
          //    b {
          //      font-size: 14px;
          //      font-weight: 700;
          //      margin: 0;
          //    }
          //  }
          //
          //  .date-attachments {
          //    font-size: 11px !important;
          //    color: $classic-grey !important;
          //    font-weight: 400;
          //    display: flex;
          //    float: right;
          //    padding: 3px 0 0 0;
          //
          //  }
          //}

          //.stage-timeline-content {
          //  background-color: red;
          //  width: 97%;
          //  padding: 5px 10px 5px 10px;
          //  border-radius: 4px !important;
          //  display: inline-flex;
          //  justify-content: space-between;
          //
          //  .stage-content {
          //    margin: 0;
          //    font-size: 14px;
          //    font-weight: 400;
          //
          //    b {
          //      font-size: 14px;
          //      font-weight: 700;
          //      margin: 0;
          //    }
          //  }
          //
          //  .date-stage {
          //    font-size: 11px !important;
          //    color: $classic-grey !important;
          //    font-weight: 400;
          //    display: flex;
          //    float: right;
          //    padding: 3px 0 0 0;
          //  }
          //}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/funnel/ListTicket.vue